<template>
    <q-card v-bind="attrs">
        <q-card-section class="q-pt-none q-pl-sm" >
            <div v-if="data[spLayer]" id="mammalPane">
                <div class="row justify-end q-pa-sm print-hide">About these data <q-icon name="help_outline" class="q-pl-sm pointer" size="xs"  @click="dataConsiderations = !dataConsiderations"/></div>
                <div class="row items-center q-pa-sm print-hide">
                    <div class="col-2">Group:<q-btn dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs[activeGroup.value].model = !infoDialogs[activeGroup.value].model" aria-label="Mammal group data help"/></div>
                    <div class="col-5 q-pa-sm">
                          <q-select class="q-ml-sm" dense outlined :options="spGroupChoices" v-model="activeGroup" @update:model-value="activeSpCode=null"></q-select>
                     </div>
                </div>
                <div class="text-h5" >{{ activeGroup.label }}</div>
                <div class="text-h6 q-mt-md row text-uppercase"><span class="text-bold">Diversity<q-btn dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['diversity'].model = !infoDialogs['diversity'].model" aria-label="Mammal diversity data help"/></span></div>
                <q-card flat class="q-pa-xs" >
                    <div class="row justify-start items-center">
                        <div class="col-6 text-center items-center text-caption">
                            <div class="row q-mt-sm"><div class="col-3 text-h5 text-bold">{{ dialVals.numSpp }}</div><div class="col-9 text-left">species estimated within this area (density >75 percentile)</div></div>
                            <div class="row q-mt-sm"><div class="col-3 text-h5 text-bold">{{ dialVals.numGTVal }}</div><div class="col-9 text-left">species at very high density levels (>95 percentile)</div></div>                
                        </div>
                        <div class="col-6 text-center items-center text-caption" v-if="activeGroup.value == 'all' && dialVals.numSpp >0">

                            <div class="row">Relative to the {{ ecos[data['majEcoregion']] }} ecoregion: 
                                <q-btn v-if="season.value == 'ALL'" dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['mammalDial'].model = !infoDialogs['mammalDial'].model" aria-label="Mammal dial help"/> 
                             </div>
                            <div class="text-center q-ml-lg dial-container"><Dial  divName="mammalDial"  :dialConfig="zDialConfig" :colors="dialColors" :dialVal="dialVals.dialVal" /></div>
                            <div class="text-center">(
                                <span v-if="dialVals.dialVal >=2.5">&ge;</span>
                                <span v-if="dialVals.dialVal <=-2.5">&le;</span>
                                {{ Math.round(dialVals.dialVal *10 ) /10}} SD)
                            </div>
                        </div>
                        <div class="q-pa-sm text-caption text-italic">Note: These values are based on annual maximums</div>
                    </div>
                </q-card>
                <div class="text-h6 text-uppercase"><span class="text-bold">Density<q-btn dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['density'].model = !infoDialogs['density'].model" aria-label="Mammal density data help"/></span></div>    
                <div class="tab-container shadow-1">
                    <q-tabs v-model="mammalTabs" class="shadow-1 q-ml-xs q-mr-xs">
                        <q-tab label="Annual Maximum"  @click="loadDataByID(spLayer, version), clearMap(), activeSpCode=null" name="density"></q-tab>
                        <q-tab label="Monthly" @click="loadDataByID(spTimeLayer, version), clearMap(), activeSpCode=null" name="time" ></q-tab>
                    </q-tabs>
                    <q-tab-panels dense v-model="mammalTabs" class="outlined">
                        <q-tab-panel name="density"  class="q-pa-xs">   
                            <q-card flat class="q-pl-sm temp-card">
                                <div class="text-h5 q-pa-sm">{{ activeGroup.label }}</div>
                                <div :style="{'min-height' : '25px'}" class="q-mt-sm">
                                    <div class="row text-caption items-center q-mb-sm q-pl-sm q-mr-sm  map-descr-row" >
                                        <div class="col-2 text-secondary">
                                            <span class="text-bold ">DATA ON THE MAP</span>:
                                        </div>
                                        <div class="col-6">
                                            <q-select
                                                :hide-bottom-space="true"
                                                dense
                                                class="secondary-dropdown q-ma-xs q-pa-xs"
                                                :options="spChoices"
                                                map-options
                                                v-model="activeSpCode"
                                                @update:model-value="rowClick(activeSpCode.value, AllCodes[activeSpCode.value])"
                                                hint="Select a species or click below"
                                                >
                                                <template v-slot:selected-item="scope">
                                                    <div class="text-bold text-secondary">
                                                        {{ scope.opt.label }}
                                                    </div>
                                                </template>
                                            </q-select>
                                        </div>
                                        <div class="col-3">
                                            <q-select 
                                                :hide-bottom-space="true"
                                                dense 
                                                class="secondary-dropdown q-ma-xs q-pl-xs q-pr-xs"  
                                                :options="layerTypes" 
                                                v-model="layerType"  
                                                @update:model-value="layerTypeChange"
                                                :hint="notSelectedTypes"
                                                >
                                                <template v-slot:selected-item="scope">
                                                    <div class="text-bold text-secondary">
                                                        {{ scope.opt.label }}
                                                    </div>
                                                </template>
                                            </q-select>
                                        </div>
                                        <div class="col-1 justify-end items-end">
                                            <q-icon name="cancel" class="pointer text-end" size="sm" color="grey" @click="clearMap(), activeSpCode=null"/>
                                        </div>     
                                    </div>
                                </div>

                                <div class="row bar-header items-end text-caption text-bold q-pr-sm">
                                    <div class="col-8 text-center">Species</div>
                                    <div class="col-2 text-right q-pl-lg">
                                        % Very High
                                        <q-btn dense size="xs" flat class="gray" icon="help_outline" @click="infoDialogs['pHigh'].model = !infoDialogs['pHigh'].model" aria-label="High threshold help"/>

                                    </div>
                                    <div class="col-1 q-pl-md">Sightings</div>
                                </div>
                                <div class="bar-rows-container q-pr-sm" 
                                    tabindex="0" 
                                    role="region" 
                                    aria-label="Scrollable bar rows"
                                >
                                    <div v-for="barCat, i in barData" 
                                        class="row bar-row justify-center pointer"
                                         @click="rowClick(barCat[0].spID, barCat[0].sp)"
                                        :class="rawSp(mapStyleInfo['attr']) === barCat[0].spID ? 'highlight shadow-1' : ''">
                                        <div class="col-10">
                                            <StackedBar 
                                                :data="barCat" 
                                                :divName="barName(i)" 
                                                categoryProp="category" 
                                                barName="sp" 
                                                valueProp="value" 
                                                class="q-mt-none" 
                                                :xAxisTicks="false"
                                                :categoryColors="barColors"
                                                :topMargin="0"  
                                                :labelFontSize="18"                            
                                            />
                                        </div>
                                        <!-- the % high + very high is repeated for each sp obj in the array, so just take the first -->
                                        <div class="col-1 text-caption">{{ barCat[0].percHighVH }}</div>
                                        <div class="col-1 text-caption pointer">
                                            <q-icon class="self-center" name="check_circle" size="xs"  color="secondary" v-if="barCat[0].sighting === 1"/> 
                                            <q-icon class="self-center" name="cancel" size="xs" v-else />
                                        </div>
                                    </div>
                                </div>
                            </q-card>             
                        </q-tab-panel>
                        <q-tab-panel name="time"  class="q-pa-xs" >
                            
                            
                            <div :style="{'min-height' : '25px'}" class="q-mt-sm" v-if="data[spTimeLayer]">
                                <div class="row text-caption items-center q-mb-sm q-pl-sm q-mr-sm  map-descr-row" >
                                    <div class="col-2 text-secondary">
                                        <span class="text-bold ">DATA ON THE MAP</span>:
                                    </div>
                                    <div class="col-4">
                                        <q-select
                                            :hide-bottom-space="true"
                                            dense
                                            class="secondary-dropdown q-ma-xs q-pa-xs"
                                            :options="monthlySpChoices"
                                            map-options
                                            v-model="activeSpCode"
                                            @update:model-value="tableCellClick(activeSpCode.value, AllCodes[activeSpCode.value])"
                                            hint="Select a species or click below"
                                            >
                                            <template v-slot:selected-item="scope">
                                                <div class="text-bold text-secondary">
                                                    {{ scope.opt.label }}
                                                </div>
                                            </template>
                                        </q-select>
                                    </div>
                                    <div class="col-2">
                                        <q-select 
                                            v-if="activeSpCode"
                                            :hide-bottom-space="true"
                                            dense 
                                            class="secondary-dropdown q-ma-xs q-pl-xs q-pr-xs"  
                                            :options="months" 
                                            v-model="month"  
                                            @update:model-value="monthChange"
                                            hint="Month"
                                            >
                                            <template v-slot:selected-item="scope">
                                                <div class="text-bold text-secondary">
                                                    {{ scope.opt.label }}
                                                </div>
                                            </template>
                                        </q-select>
                         
                                    </div>
                                    <div class="col-3">
                                        <q-select 
                                            v-if="activeSpCode && month"
                                            :hide-bottom-space="true"
                                            dense 
                                            class="secondary-dropdown q-ma-xs q-pl-xs q-pr-xs"  
                                            :options="monthLayerTypes" 
                                            v-model="monthLayerType"  
                                            @update:model-value="tableCellClick(activeSpCode.value, AllCodes[activeSpCode.value])"
                                            :hint="notSelectedMonthTypes"
                                            >
                                            <template v-slot:selected-item="scope">
                                                <div class="text-bold text-secondary">
                                                    {{ scope.opt.label }}
                                                </div>
                                            </template>
                                        </q-select>
                                    </div>
                                    <div class="col-1 justify-end items-end">
                                        <q-icon name="cancel" class="pointer text-end" size="sm" color="grey" @click="clearMap()"/>
                                        
                                    </div>     
                                </div>
                            </div>
                            
                            <div v-if="data[spTimeLayer]" class="time-table-container">
                                <Table 
                                    :version="version"
                                    :rows="mammalMonthData" 
                                    :columns="columns"
                                    title=""
                                    :expandRows="false"
                                    :mapStyle="true"
                                    :mapStops="stops['spp_95max']"
                                    :dqStops=" dqStops['quality_4cls']"
                                    :dqClassNames="qualityClasses"
                                    :mapClassNames="legendColorStopNames"
                                    :cellColors="tableCellColors"
                                    :labelCells="false"
                                    :mapLayer=spTimeLayer
                                    :mapLegendTitles="mammalMonthLegendTitles"
                                    :selSp="activeSpCode ? activeSpCode : null"
                                    :selMonth="month ? month : null"
                                    @cellClick="tableClickEmitFunc"
                                >
                                
                                </Table>

                                
                            </div> 
                            <div v-else class="row justify-center">
                                <q-spinner size="lg"></q-spinner>
                            </div>
                        </q-tab-panel>
                    </q-tab-panels>
                </div>
                <div class="row text-center justify-center q-mt-md q-mb-sm">
                    <div class="col-2" :style="{'background-color' : barColors['Very High'], 'color' :'white'}">Very High<br/>(>95)</div>
                    <div class="col-2" :style="{'background-color' : barColors['High']}">High<br/>(>90)</div>
                    <div class="col-2" :style="{'background-color' : barColors['Medium']}">Medium<br/>(>75)</div>
                    <div class="col-2" :style="{'background-color' : barColors['Low']}">Low<br/>(>0)</div>
                    <div class="col-2" :style="{'background-color' : barColors['No Data']}">No Data</div>
                </div>
            </div>
            <div v-else class="row justify-center">
                <q-spinner size="lg"></q-spinner>
            </div>
        </q-card-section>
    </q-card>
    <div v-for="(infoObj, name) in infoDialogs" :key="name" >
        <q-dialog v-model="infoObj.model">
            <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
        </q-dialog>
    </div>
    <template>
        <q-dialog v-model="dataConsiderations">
            <q-card>
            <q-card-section>
                <SpeciesDataConsiderations groupsToShow="mammals" />
            </q-card-section>
            <q-card-actions align="right">
                <q-btn flat label="OK" color="primary" @click="dataConsiderations = false" />
            </q-card-actions>
            </q-card>
        </q-dialog>
    </template>
</template>
<script setup lang="ts">
import { toRefs, ref, onMounted, onUnmounted, computed, useAttrs } from "vue";
import { QTableColumn } from 'quasar';
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import { stops, dqStops } from "../assets/ColorStops.json"
import Dial from "./Dial.vue";
import StackedBar from "./StackedBar.vue";
import Table from "./Table.vue";
import InfoDialog from "./InfoDialog.vue";
import SpeciesDataConsiderations from "./SpeciesDataConsiderations.vue";
import { MammalGroups } from "../assets/MammalGroups.json"
import { MammalMeanSDs } from "../assets/MeanSDs.json"
import { AllCodes } from "../assets/SppCodesToNames.json"
const {  setMapNotes, mapNotes, processDialData, processStackedBarData, processMonthData, ecos,  styleMap, setLegend, mapStyleInfo, clearMapStyle, activeLayerID, setDataQuality, loadDataByID, processedData, getData, userPolygon, activeSpGroups, setActiveSpGroups } = useMapItems()
const {  arrayFindObjectByProp, logGAevent } = useHelpers();
const attrs = useAttrs();


const props = defineProps({
    data: { type: Object },
    version: {type: Number},
    ecoregion: {type: String},
})

const {  data, version, ecoregion } = toRefs(props)

///////// Get data for dials, annual bar data & monthly (table data)
// DIALS
const dialVals = computed(() =>{
    // the 2nd to last value is the threshold for "spp supported by this site"
    // the last value (90) is used as the threshold for defining very high abundance.  # of sp with presence >= that value in AOI
    const val = processDialData(version, data, spLayer, activeGroup, ecoregion.value, season, MammalGroups, MammalMeanSDs, 75, 95)
    return val
})

const zDialConfig = computed(() =>{
    return {
        minVal: -2.5,   //dial min value
        maxVal: 2.5,    //dial max value
        majorTicks: 35, //this is the number of color gradations
        ticks: [-2, -1, 0, 1, 2],  //numberical label
        labels: ["Far Less", "Less", "Avg", "More", "Far More"],  //optional array of pretty names that will replace numerical.  Must be in same order
        labelSize: 10  //px size of the labels
    }
})

// Annual data BAR CHARTS
const barData = computed(() =>{
    const percHVHVals = [95] // values that are used to calculate the % high & very high abundance
    const sightingSuffix = "_S" // if included, it is a 0/1 field with the suffix on the sp name as in "WSDO_S" that indicates if the sp has been sighted    
    
    let barData =  processStackedBarData(version, data, spLayer, activeGroup, MammalGroups, AllCodes, barCategories, barSortOrder, percHVHVals, sightingSuffix)
    
    if (barData == "need data"){ 
        // this can happen if a group is selected then a share link is used.  When returning, not all
        // groups are necessarily in the processedData object, so need to fetch the cellData again
        getData(userPolygon.value.polyID, 1, true)
        barData =  processStackedBarData(version, data, spLayer, activeGroup, MammalGroups, AllCodes, barCategories, barSortOrder, percHVHVals, sightingSuffix)
    }
    return barData
})
const dialColors = {'color1' :'#F1FDFC', 'color2' : '#1D8177', 'color3' :'#02524a'}
const barColors ={
    "Very High" : "#830C5D",
    "High" : "#F16DC6",
    "Medium" : "#EEB3DA",
    "Low"  : "#F7E8F2",
    "No Data" : "#a1a1a1"
}
const barSortOrder = ["Very High", "High", "Medium", "Low",  "No Data"]
const barCategories = {
        "-9" : "No Data",
        "0" : "Low",
        "75" : "Medium",
        "90" : "High",
        "95" : "Very High"
}
const barName = (i) =>{
    return "mammalBar" + i
}

// Monthly TABLE DATA
const mammalMonthData=  computed(() =>{
    const sortOrder = getSpIDs(barData.value)
    const monthData = processMonthData(spTimeLayer, version, activeGroup, data, MammalGroups, AllCodes, sortOrder)
    return monthData
})

const columns: QTableColumn[] = [
    { name: 'name', required: true, label: 'Species', align: 'left',field: 'name', sortable: true, style: 'padding-left: 3px; width: 55px; max-width: 55px;'  },
    { name: 'Jan', align: 'center', label: 'Jan', field: 'Jan', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;'  },
    { name: 'Feb', align: 'center', label: 'Feb', field: 'Feb', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Mar', align: 'center', label: 'Mar', field: 'Mar', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Apr', align: 'center', label: 'Apr', field: 'Apr', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'May', align: 'center', label: 'May', field: 'May', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Jun', align: 'center', label: 'Jun', field: 'Jun', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Jul', align: 'center', label: 'Jul', field: 'Jul', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Aug', align: 'center', label: 'Aug', field: 'Aug', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Sep', align: 'center', label: 'Sep', field: 'Sep', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Oct', align: 'center', label: 'Oct', field: 'Oct', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Nov', align: 'center', label: 'Nov', field: 'Nov', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Dec', align: 'center', label: 'Dec', field: 'Dec', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
 ]
 const tableCellColors ={
    "95" : "#830C5D",
    "90" : "#F16DC6",
    "75" : "#EEB3DA",
    // "1" : "#ffffb2",
    "0"  : "#F7E8F2",
    "-9" : "#a1a1a1"
}
const mammalMonthLegendTitles = computed(() =>{
    // used in the map legend-- needed so that year is updated
    // when you click on a table column
    const titles = {
        "Jan" : "density (Jan)",
        "Feb" : "density (Feb)",
        "Mar" : "density (Mar)",
        "Apr" : "density (Apr)",
        "May" : "density (May)",
        "Jun" : "density (Jun)",
        "Jul" : "density (Jul)",
        "Aug" : "density (Aug)",
        "Sep" : "density (Sep)",
        "Oct" : "density (Oct)",
        "Nov" : "density (Nov)",
        "Dec" : "density (Dec)"
    }
    return titles
})


// the currently selected group: shared between monthly & annual data
const spGroupChoices = computed(() =>{
    const choices =[]
    for (const [key, value] of Object.entries(MammalGroups)) {
        choices.push({value: key, label: spGroupPrettyNames[key]})
    }
    // console.log(choices)
    return choices
})
const activeGroup = computed({
    get: () => {
        const gr = activeSpGroups.value['mammals']
        const grObj = arrayFindObjectByProp(spGroupChoices.value, "value", gr)
        return grObj
    },
    set: (value) => {
        setActiveSpGroups("mammals", value.value)
        logGAevent("mammal_group",  value.value, "")
    }
});
const spGroupPrettyNames ={
    "all": "All Marine Mammals",
    "esa": "ESA listed species",
    "nersgcnconservation": "High value for conservation by NE RGSCN",
    "dolphin": "Small dolphins",
    "baleen": "Baleen Whales",
    "large": "Large Dolphins",
    "tooth": "Tooth Whales",
    "lowfreq": "Sensitive to low freq. sounds",
    "highfreq": "Sensitive to high freq. sounds",
    "vhighfreq": "Sensitive to very high freq. sounds"
}


// if spLayer is a computed property, then the barGraphs computed property
// updates twice on season change.  Better for spLayer to be updated directly when season is
const spLayer = ref("MAMMAL_YEAR")
const spTimeLayer = ref("MAMMAL_MONTH")

const season = ref({value: "ALL", label: "All Year"})


// setup the data needed for the annual data dropdowns
const layerType = ref({value: "density", label : "Density"})
const layerTypes = [
    {label : "Density", value: "density"}, 
    {label : "Sightings", value: "sightings"}, 
    {label : "Confidence", value: "quality"}, 
]

const notSelectedTypes = computed(() =>{
    let notSel = ""
    for (const typeObj of layerTypes){
        if (typeObj.value != layerType.value.value){
            notSel += `${typeObj.label}, `
        }
    }
    return notSel.slice(0, -2);
})

const activeSpCode =ref({value: "", label: ""})
const spChoices  = computed(() =>{
    const choices =[]
    MammalGroups[activeGroup.value.value].forEach((sp) =>{
        choices.push({value: sp, label: AllCodes[sp]})
    })
    // console.log(choices)
    return choices
});

const monthlySpChoices = computed(() =>{
    const choices =[]
    MammalGroups[activeGroup.value.value].forEach((sp) =>{
        if (monthlyMammals.includes(sp)){
            choices.push({value: sp, label: AllCodes[sp]})
        }
    })
    // console.log(choices)
    return choices
})

const layerTypeChange = () =>{
    // console.log(mapStyleInfo)
    const spID = mapStyleInfo.value['attr']
    let attr = spID
    if(spID.endsWith("_S")){
        attr = spID.replace("_S", "")
    }
    const sp = AllCodes[attr]
    rowClick(attr, sp)
}

const rawSp = (attr) =>{
    if (attr){
        return attr.replace("_S", "")
    }
}

const getSpIDs = (data) => {
    // used so that species in  monthly data are in same order as annual data
    return data.map(subArray => subArray[0].spID);
}

const rowClick = (spID, sp) =>{
    
    activeSpCode.value = spID;
    let lyrID =activeLayerID.value
    logGAevent("mammal_row_click", lyrID, spID)
    if (layerType.value.value == 'density'){
        if (activeLayerID.value.includes("QUALITY")){
            lyrID = activeLayerID.value.replace("_QUALITY", "")
            setDataQuality(false)
            loadDataByID(lyrID, version.value)
        }
        styleMap(lyrID, spID, 'categorical', stops['spp_95max'], legendColorStopNames) 
        setLegend(sp + ' Estimated Density (Annual max.)', stops['spp_95max'], legendColorStopNames)
    }
    else if (layerType.value.value == 'sightings'){
        if (activeLayerID.value.includes("QUALITY")){
            lyrID = activeLayerID.value.replace("_QUALITY", "")
            setDataQuality(false)
            loadDataByID(lyrID, version.value)
        }
        const attr = spID + "_S"
        const names = {
            "1" : "Sighting",
            "0" : "No Sighting"
        }
        styleMap(lyrID, attr, 'categorical', stops['sighting'], names), 
        setLegend(sp + ' Sightings', stops['sighting'], names)
        
    }


    else if (layerType.value.value == 'quality'){
        if (!activeLayerID.value.includes("QUALITY")){
            lyrID = activeLayerID.value + "_QUALITY"
            setDataQuality(true)
            loadDataByID(lyrID, version.value)
        }

        let attr = spID
        styleMap(lyrID, attr, 'categorical',  dqStops['quality_4cls'], qualityClasses)
        setLegend(sp + ':  % of months with high confidence', dqStops['quality_4cls'],  qualityClasses)
        mammalConfidenceNote(spID)
    }
    else{lyrID = activeLayerID.value}
    
}

// setup data for monthly data map control dropdowns & bind to table
const monthLayerType = ref({value: "density", label : "Density"})
const monthLayerTypes = [
    {label : "Density", value: "density"}, 
    {label : "Confidence", value: "quality"}, 
]

const notSelectedMonthTypes = computed(() =>{
    let notSel = ""
    for (const typeObj of monthLayerTypes){
        if (typeObj.value != monthLayerType.value.value){
            notSel += `${typeObj.label}, `
        }
    }
    return notSel.slice(0, -2);
})

const tableClickEmitFunc = (e) =>{
    // console.log(e)
    // console.log(monthLayerType)
    const spID = e.sp;
    month.value = arrayFindObjectByProp(months, "value", e.month)
    tableCellClick(spID, AllCodes[spID])

}

const tableCellClick = (spID, sp) =>{
    
    if (typeof spID === 'object'){
        activeSpCode.value= spID
    }
    else{
        activeSpCode.value = {value: spID, label: sp};
    }

    let lyrID =activeLayerID.value
    if (activeSpCode.value && month.value){
        logGAevent("mammal_table_click",   activeSpCode.value.value, month.value.value)
        
        

        if (monthLayerType.value.value == 'density'){
            if (activeLayerID.value.includes("QUALITY")){
                lyrID = activeLayerID.value.replace("_QUALITY", "")
                setDataQuality(false)
                loadDataByID(lyrID, version.value)
            }
            let attr = spID + "_" + month.value.value
            styleMap(lyrID, attr, 'categorical', stops['spp_95max'], legendColorStopNames) 
            setLegend(sp + " (" +month.value.label+"): Estimated Density", stops['spp_95max'], legendColorStopNames)
        }

        else if (monthLayerType.value.value == 'quality'){
            if (!activeLayerID.value.includes("QUALITY")){
                lyrID = activeLayerID.value + "_QUALITY"
                setDataQuality(true)
                loadDataByID(lyrID, version.value)
            }

            let attr = spID + "_" + month.value.value
            styleMap(lyrID, attr, 'categorical',  dqStops['quality_4cls'], qualityClasses)
            setLegend(sp + " (" + month.value.label + "): Data Confidence", dqStops['quality_4cls'],  qualityClasses)
            mammalConfidenceNote(spID)
        }
        else{lyrID = activeLayerID.value}
        
    }
}


const clearMap = () =>{
    layerType.value = {value: "density", label : "Density"};
    monthLayerType.value = {value: "density", label : "Density"};
    clearMapStyle();
    activeSpCode.value = null;
    month.value = null;
}

const month = ref({value: "M01",  label: "Jan"})

const monthChange = (e) =>{
    // console.log(e)
    month.value = arrayFindObjectByProp(months, "value", e.value)
    tableCellClick(activeSpCode.value.value, AllCodes[activeSpCode.value.value])
}

const months = [
    {value: "M01",  label: "Jan"},
    {value: "M02",  label: "Feb"},
    {value: "M03",  label: "Mar"},
    {value: "M04",  label: "Apr"},
    {value: "M05",  label: "May"},
    {value: "M06",  label: "Jun"},
    {value: "M07",  label: "Jul"},
    {value: "M08",  label: "Aug"},
    {value: "M09",  label: "Sep"},
    {value: "M10",  label: "Oct"},
    {value: "M11",  label: "Nov"},
    {value: "M12",  label: "Dec"},
]


const dataConsiderations = ref(false)
const mammalTabs = ref('density')
const legendColorStopNames ={
    '-9' : "No Data",
    "0" : "Low",
    "75" : "Medium", 
    "90" : "High", 
    "95" : "Very High"
}
const qualityClasses = {
    "-9" : "No Data",
    "1" : "Highest",
    "2" : "Medium",
    "3" : "Low",
    "4" : "Lowest"
}

const monthlyMammals = ["ASDO", "BODO", "FIWH", "GRAM", "HAPO", "HUWH", "MIWH", "RIWH", "SADO", "SEWH", "SPWH", "UNSE", "WSDO"]
const noMonthlyMammals = ["BEWH", "BLWH", "CLDO", "FKWH", "FRDO", "GOBW", "KIWH", "MHWH", "NBWH", "PIWH", "PSDO", "PYKW", "RTDO", "SNDO", "STDO", "UNBW", "UNKO", "WBDO"]


const mammalConfidenceNote = (spID) =>{
        if (spID && layerType.value.value == 'quality'){ 
        // remove any previous notes about confidence
        mapNotes.value.forEach((note) =>{
            if (note.includes('confidence')){
                setMapNotes(false, note)
            }
        })


        if (monthlyMammals.includes(spID)){
            setMapNotes(true, `The annual confidence data for ${AllCodes[spID]} is based on the number of months with 'very high' confidence`)
        }
        else if (noMonthlyMammals.includes(spID)){
            setMapNotes(true, `${AllCodes[spID]} data is only available annually, so there is no information of confidence across the year.`)
        }
    }
    else if (!spID){
        mapNotes.value.forEach((note) =>{
            if (note.includes('confidence')){
                setMapNotes(false, note)
            }
        })
    }
}

const infoDialogs = ref({
  mammalMonths: {
    pName: "Monthly Data",
    model: false,
        text: "Please note that monthly data is only available for a subset of marine mammal species."
  },
  diversity: {
    pName: "Diversity Data",
    model: false,
    text: "Diversity values show the number of mammal species that have estimated density values beyond the 'Very High' threshold, or above the 95th percentile, in the area of interest. Estimated density values originate from Duke University's Habitat-based Marine Mammal Density Models for the US Atlantic (Roberts et al. 2016, 2023).  <div class='q-pt-sm'>The dial graphic displaying diversity relative to the ecoregion is only available for the 'All Mammals' group.</div>"
  },
  density: {
    pName: "Density Data",
    model: false,
    text: "Estimated density values originate from the Duke University's Habitat-based Marine Mammal Density Models for the US Atlantic (Roberts et al. 2016, 2023).  Threshold values are calculated by species across time. Yearly values are maximum values across all months. Note that monthly data is only available for a subset of species."
  },
  all: {
    pName: "All Mammals",
    model: false,
    text: "This group includes all species of marine mammals that have model data available within our region. "
  },
  esa: {
    pName: "ESA listed species",
    model: false,
    text: "This group includes marine mammals that are listed as Endangered under the Endangered Species Act (ESA). It includes Blue whale, Fin whale, Humpback whale, North Atlantic right whale, Sei whale, and Sperm whale. Note that there may be other ESA-listed species that have no data available within our region. "
  },
  nersgcnconservation: {
    pName: "High value for conservation by NE RGSCN",
    model: false,
    text: "This group includes marine mammal species that are considered High or Very High value for conservation by the Northeast Fish & Wildlife Technical committee. This includes the following species: Blue Whale, Fin Whale, Humpback Whale, North-atlantic Right Whale, Sei Whale, and Sperm Whale.   Note that there may be other high priority species that have no data available within our region. "
  },
  dolphin: {
    pName: "Small Dolphnis",
    model: false,
    text: "This group includes small-sized species of delphinoids and harbor porpoise. This species group was created by a group of experts convened by the Regional Data Portals. It includes Atlantic spotted dolphin, Atlantic white-sided dolphin, Common bottlenose dolphin, Clymene dolphin, Fraser's dolphin, Harbor porpoise, Pantropical spotted dolphin, Rough-toothed dolphin, Short-beaked common dolphin, Spinner dolphin, Striped dolphin, and White-beaked dolphin. Note that there may be other species in this group that have no data available within our region. "
  },
  baleen: {
    pName: "Baleen Whales",
    model: false,
    text: "This group includes all modelled species of Baleen whales (also known as whalebone whales or mysticetes). This species group was created by a group of experts convened by the Regional Data Portals. It includes Blue whale, Fin whale, Humpback whale, Minke whale, North Atlantic right whale, and Sei whale. Note that there may be other species in this group that have no data available within our region. "
  },
  large: {
    pName: "Large Dolphins",
    model: false,
    text: "This group includes large-sized species of delphinoids, including pilot whales and killer whales. This species group was created by a group of experts convened by the Regional Data Portals. It includes False killer whale, Risso's dolphin, Killer whale, Melon-headed whale, and Pilot whales. Note that there may be other species in this group that have no data available within our region. "
  },
  tooth: {
    pName: "Toothed Whales",
    model: false,
    text: "This group includes all modelled species of toothed whales (also known as odontocetes). This species group was created by a group of experts convened by the Regional Data Portals. It includes Mesoplodont beaked whales, Cuvier's beaked whale, Dwarf and pygmy sperm whales, Pygmy killer whale, Sperm whale, and Unidentified beaked whales. Note that there may be other species in this group that have no data available within our region. "
  },
  lowfreq: {
    pName: "Sensitive to low freq. sounds",
    model: false,
    text: "This group includes marine mammals considered sensitive to Low-Frequency anthropogenic noise. See Southall et al. 2019 for more information. It includes Blue whale, Fin whale, Humpback whale, Minke whale, North-atlantic Right whale, and Sei whale. Note that there may be other species in this group that have no data available within our region. "
  },
  highfreq: {
    pName: "Sensitive to high freq. sounds",
    model: false,
    text: "This group includes marine mammals considered sensitive to High-Frequency anthropogenic noise. See Southall et al. 2019 for more information. It includes Atlantic spotted dolphin, Atlantic white-sided dolphin, Mesoplodont beaked whales, Common bottlenose dolphin, Cuvier's beaked whale, Clymene dolphin, False killer whale, Fraser's dolphin, Risso's dolphin, Killer whale, Melon-headed whale, Northern bottlenose whale, Pilot whales, Pantropical spotted dolphin, Pygmy killer whale, Rough-toothed dolphin, Short-beaked common dolphin, Spinner dolphin, Sperm whale, Striped dolphin, Unidentified beaked whales, and White-beaked dolphin. Note that there may be other species in this group that have no data available within our region. "
  },
  vhighfreq: {
    pName: "Sensitive to very high freq. sounds",
    model: false,
    text: "This group includes marine mammals considered sensitive to Very High-Frequency anthropogenic noise. See Southall et al. 2019 for more information. It includes Harbor porpoise, Dwarf and pygmy sperm whales, and Seals. Note that there may be other species in this group that have no data available within our region. "
  },
  mammalDial:{
    pName: "Mammal Relative Diversity Dials",
    model: false,
    text: "These dials are based on diversity values for the area of study compared to the ecoregional averages. Diversity values are calculated by adding the number of species that have estimated densities beyond the 'Very high' threshold (95th percentile). The reference values for the ecoregions are the following (mean|st. deviation) : Gulf of Maine (4.03|1.88); Virginian (2.67|1.54); Carolinian (0.67|0.9). "
  },
  pHigh: {
    pName: "Percent Very High",
    model: false,
    text: "This value shows the percent of the area that is above the 'Very High' threshold (>95th percentile)"
  }
})

onMounted(() => {
    if (activeLayerID.value !== spLayer.value) {
        loadDataByID(spLayer.value, version);
    }

    const mapStyle = processedData.value['mapStyle'];
    if (mapStyle) {
        const attr = mapStyle['attr'];
        const layerID = mapStyle['layerID'];

        if (attr.includes("_S")) {
            layerType.value = { value: "sightings", label: "Sightings" };
            activeSpCode.value = {
                value: attr.replace("_S", ""),
                label: AllCodes[attr.replace("_S", "")]
            };
            // console.log(activeSpCode.value);
        }

        if (layerID.includes("_QUALITY")) {
            layerType.value = { value: "quality", label: "Confidence" };
            if (!activeLayerID.value.includes("_QUALITY")) {
                const qualLayerID = `${activeLayerID.value}_QUALITY`;
                loadDataByID(qualLayerID, version);
            }
        }
    }
});

onUnmounted(() =>{
    clearMap();
    activeSpCode.value=null;
    mammalConfidenceNote(null)
})

</script>
<style scoped>

.highlight{
    /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
    border: 1px solid #aeaeae;
    margin: 3px;
    border-radius: 3px;
    position: relative;
    z-index: 10;
    /* margin-right: 3px; */
    /* padding-bottom:0px; */
    min-height: 12px !important; 
}

.bar-row{
    max-height: 30px;
    min-height: 20px;
    /* overflow: hidden; */
}
.dial-container{
    max-width: 200px;
}
.bar-rows-container{
    padding: 5px;
    max-height: 250px;
    overflow: auto;
    outline: none; /* Remove default focus outline */
}

.bar-rows-container:focus {
  outline: 2px solid #24302b; /* Add custom focus outline */
}

.mapActive{
    background-color: #1D8177;
}

.bordered{
    border: 1px solid black;
    text-align: center;
    max-height: 18px;
    vertical-align: middle;
    border-radius: 3px;
}
.time-table-container{
    max-width: 500px;
}
.tab-container{
    border-radius: 3px;
    border: 1px solid #aeaeae;
    border-radius: 5px;
}
.secondary-dropdown{
    border: 1px solid #1D8177;
    border-radius: 5px;
    min-height:70px;
    font-size: small;
}
.map-descr-row{
    background-color: #F1FDFC;
}
.pointer{
    cursor: pointer;
}
</style>